import React, { useEffect, useState } from "react";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui.css";
import "jquery-ui-dist/jquery-ui.js";
import { baseurl } from "../../../component/Baseurl";
import axios from "axios";
import Swal from "sweetalert2";

function PackageForm({ packageid }) {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    departureDate: "",
    returnDate: ""
  });

  useEffect(() => {
    $("#departureDate").datepicker({
      dateFormat: "yy-mm-dd",
      minDate: 0,
      onSelect: function (selectedDate) {
        $("#returnDate").datepicker("option", "minDate", selectedDate);
        setFormData((prev) => ({ ...prev, departureDate: selectedDate }));
      },
    });

    $("#returnDate").datepicker({
      dateFormat: "yy-mm-dd",
      minDate: 0,
      onSelect: function (selectedDate) {
        setFormData((prev) => ({ ...prev, returnDate: selectedDate }));
      },
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const requestData = {
      package_id: packageid,
      ...formData,
    };
  
    console.log("Sending booking request data:", requestData); // Log data before sending
  
    try {
      const response = await axios.post(`${baseurl}InsertBooking`, requestData);
      console.log("Response from server:", response.data); // Log server response
  
      Swal.fire({
        icon: "success",
        title: "Inquiry Submitted Successfully!",
        text: "Our team will contact you soon.",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      }).then(() => {
        window.location.reload(); // Reload the page after clicking OK
      });
  
      setFormData({
        name: "",
        phone: "",
        email: "",
        departureDate: "",
        returnDate: ""
      });
  
    } catch (error) {
      console.error("Error sending booking request:", error);
  
      Swal.fire({
        icon: "error",
        title: "Failed to Send Inquiry",
        text: "Please try again later.",
        confirmButtonColor: "#d33",
        confirmButtonText: "OK",
      });
    }
  };
  
  
  

  return (
    <div className="bg-white p-3 rounded form-box box_detail">
      <h4 className="txt5">Booking by Email</h4>
      <form className="text-start row g-0" onSubmit={handleSubmit}>
        <div className="col-12">
          <label className="form-label labelset3">Name</label>
          <input type="text" name="name" className="input-field" placeholder="Enter Full Name" value={formData.name} onChange={handleChange} required />
        </div>
        <div className="col-12">
          <label className="form-label labelset3">Phone</label>
          <input type="text" name="phone" className="input-field" placeholder="Enter Phone Number" value={formData.phone} onChange={handleChange} required />
        </div>
        <div className="col-12">
          <label className="form-label labelset3">Email</label>
          <input type="email" name="email" className="input-field" placeholder="Enter Email" value={formData.email} onChange={handleChange} required />
        </div>
        <div className="col-12">
          <label className="form-label labelset3">Departure Date</label>
          <input type="text" id="departureDate" name="departureDate" className="input-field" placeholder="Select Departure Date" required readOnly />
        </div>
        <div className="col-12">
          <label className="form-label labelset3">Return Date</label>
          <input type="text" id="returnDate" name="returnDate" className="input-field" placeholder="Select Return Date" required readOnly />
        </div>
        <div className="mb-2 text-end">
          <button className="book-btn" type="submit">Send Inquiry</button>
        </div>
      </form>
    </div>
  );
}

export default PackageForm;